import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { BioService } from '../../../../core/services/bio.service';
import { BioRender } from './BioRender';
import useBodyClass from '../../../../hooks/useBodyClass';
import { PublicPageUnavailable } from '../../../common/public-page-unavailable/PublicPageUnavailable';

const getVisitorId = (): string => {
    try {
        let id = localStorage.getItem('cc_bio_vid');
        if (!id) { id = 'v_' + Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem('cc_bio_vid', id); }
        return id;
    } catch { return 'v_anon'; }
};
const getSessionId = (): string => {
    try {
        let id = sessionStorage.getItem('cc_bio_sid');
        if (!id) { id = 's_' + Math.random().toString(36).slice(2) + Date.now().toString(36); sessionStorage.setItem('cc_bio_sid', id); }
        return id;
    } catch { return 's_anon'; }
};
export const PublicBioPage: React.FC = () => {
    const { slug } = useParams<{ slug: string }>();
    const [page, setPage] = useState<any>(null);
    const [blocks, setBlocks] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    useBodyClass('bio-public-page');
    useEffect(() => {
        if (!slug) return;
        BioService.getPublicBioPage(slug)
            .then((res: any) => {
                if (res?.status === 1 && res?.data?.page) {
                    setPage(res.data.page);
                    setBlocks(res.data.blocks || []);
                    BioService.trackView({ slug, visitor_id: getVisitorId(), session_id: getSessionId() });
                } else {
                    setError('Page not found');
                }
            })
            .catch(() => setError('Failed to load page'))
            .finally(() => setLoading(false));
    }, [slug]);

    const outerBg = 'linear-gradient(160deg, #e8f0fe 0%, #f0e6ff 45%, #fde8f0 100%)';

    if (loading) return (
        <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: outerBg }}>
            <CircularProgress size={38} thickness={3} />
        </Box>
    );
    // OLD: a bare grey line of text.
    // if (error) return (
    //     <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: outerBg, p: 3 }}>
    //         <Box sx={{ textAlign: 'center', opacity: 0.55, fontSize: 14 }}>{error}</Box>
    //     </Box>
    // );
    // The API now also returns "not found" when the owner's plan no longer
    // includes link-in-bio, so this branch is what an expired page shows —
    // it needs to look intentional rather than broken.
    if (error) return <PublicPageUnavailable variant="bio" />;

    const bioContent = (
        <BioRender
            page={page}
            blocks={blocks}
            hrefFor={(b) => b.click_token ? BioService.clickUrl(b.click_token) : (b.url || '')}
        />
    );

    return (
        <Box sx={{
            minHeight: 'calc(100vh - 0px)',
            display: 'flex',
            justifyContent: 'center',
            background: '#fff',
        }}>
            <Box sx={{ width: '500px', maxWidth: '100%', minHeight: 'calc(100vh - 0px)', border:'1px solid #ececec' }}>
                {bioContent}
            </Box>
        </Box>
    );
};
